export class AddressModel {
	addressLine1?: string;
	addressLine1Error?: any;
	addressLine2?: string;
	addressLine3?: string;
	city?: string;
	county?: string;
	postcode?: string;
	postcodeError?: any;
	country?: string;
	countryError?: string;
	borough?: string;
	boroughError?: string;
	lat?: number;
	lng?: number;

	constructor(data: any = {}) {
		this.addressLine1 = data.addressLine1 || "";
		this.addressLine2 = data.addressLine2 || "";
		this.addressLine3 = data.addressLine3 || "";
		this.city = data.city || "";
		this.county = data.county || "";
		this.postcode = data.postcode || "";
		this.country = data.country || "";
		this.borough = data.borough || "";
		this.lat = data.lat || undefined;
		this.lng = data.lng || undefined;
	}
}
